/**
 * Catálogo de mensagens genéricas de erro (cross-cutting), em pt-BR e sem
 * termos técnicos. Mensagens específicas de domínio NÃO pertencem aqui —
 * ficam no call site como fallback de `getApiErrorMessage`.
 */
export const API_ERROR_MESSAGES = {
  GENERIC_ERROR: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
  NETWORK_ERROR: 'Sem conexão. Verifique sua internet e tente novamente.',
  TIMEOUT_ERROR: 'A operação demorou mais que o esperado. Tente novamente.',
  SESSION_EXPIRED: 'Sua sessão expirou. Entre novamente para continuar.',
  FORBIDDEN: 'Você não tem permissão para esta ação.',
  NOT_FOUND: 'O item solicitado não foi encontrado.',
  SERVER_ERROR: 'Não foi possível concluir. Tente novamente em instantes.'
} as const

export type ApiErrorMessageKey = keyof typeof API_ERROR_MESSAGES
